module.exports = __webpack_public_path__ + "static/media/play-stone-boss-5.49e54192.png";